import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineCommentApi } from '@/features/api/hooks/grapevine-comment/useGrapevineCommentApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetComments = (postId = '') => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineCommentApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.COMMENTS, postId],
    queryFn: () =>
      api.getAllCommentsForPost({
        postId
      }),
    enabled: isAuthenticated && !isEmptyOrNull(postId)
  });
};
